import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/card/Card';
import AirportFacilityDetails from 'common/airport/AirportFacilityDetails';
import PriceDisplay from 'common/airport/PriceDisplay';

const SearchAirportStructuredDataCard = ({
    spot: {
        facility
    },
    destinationUrl,
    onStructuredDataClick,
}) => (
    <section
        className="SearchAirportStructuredDataCard"
        itemProp="item"
        itemScope
        itemType="http://schema.org/Product"
        onClick={onStructuredDataClick}
    >
        <Card>
            <link
                itemProp="url"
                href={`${destinationUrl}?spot=${facility.id}`} // structured data requires each item to have a unique url
            />
            <div className="SearchAirportStructuredDataCard-location">
                <div className="SearchAirportStructuredDataCard-description">
                    <AirportFacilityDetails
                        facility={facility}
                        hideAdminLink
                    />
                </div>
                <div
                    className="PriceContainer"
                    itemProp="offers"
                    itemScope
                    itemType="http://schema.org/Offer"
                >
                    <meta
                        itemProp="name"
                        content="Parking"
                    />
                    <meta
                        itemProp="description"
                        content={`Reserved Parking at ${facility.title}`}
                    />
                    <span
                        itemProp="seller"
                        itemScope
                        itemType="http://schema.org/Organization"
                    >
                        <meta
                            itemProp="name"
                            content="SpotHero"
                        />
                        <meta
                            itemProp="url"
                            content="https://spothero.com"
                        />
                    </span>
                    <meta
                        itemProp="availability"
                        content="http://schema.org/InStock"
                    />
                    <PriceDisplay
                        isDefault
                        price={facility.lowestDailyRate}
                    />
                </div>
            </div>
        </Card>
    </section>
);

SearchAirportStructuredDataCard.propTypes = {
    spot: PropTypes.object.isRequired,
    destinationUrl: PropTypes.string.isRequired,
    onStructuredDataClick: PropTypes.func.isRequired
};

export default SearchAirportStructuredDataCard;
